import { useMaterialUIController } from "../../context";
import CHECK_DISPLAYS from "../../assets/icons/check-displays.js";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";
import React from "react";
import { formatDate } from "../../utils/date.js";

const HomeworkMilestone = ({
  id,
  date,
  description,
  done,
  submitted,
  disabled,
  size = "1em",
  onClick,
  validation_mode,
  validation_params,
  ...other
}) => {
  const [controller] = useMaterialUIController();
  const Icon = CHECK_DISPLAYS[controller.checkStyle][done || submitted ? "done" : "none"];

  const plusTwo = new Date();
  plusTwo.setTime(plusTwo.getTime() + 2 * 86400000);
  plusTwo.setHours(0);
  plusTwo.setMinutes(0);
  plusTwo.setSeconds(0);
  plusTwo.setMilliseconds(0);
  let color = "#555";
  if (done) {
    color = "#43A047";
  } else if (submitted) {
    color = "#FB8C00";
  } else if (date && new Date(date + "T23:59:59") < new Date()) {
    color = "#E53935";
  } else if (date && new Date(date + "T00:00:00") < plusTwo) {
    color = "#FB8C00";
  }

  return (
    <Tooltip title={[date ? formatDate(date) : "", description].filter((p) => !!p).join(" - ")}>
      <Icon
        {...other}
        sx={{
          width: size,
          height: size,
          color: color,
          cursor: !disabled && onClick ? "pointer" : "default",
          opacity: disabled ? 0.3 : 1,
        }}
        onClick={disabled ? undefined : onClick}
      />
    </Tooltip>
  );
};

HomeworkMilestone.propTypes = {
  id: PropTypes.string,
  date: PropTypes.string,
  description: PropTypes.string,
  validation_mode: PropTypes.string,
  validation_params: PropTypes.object,
  done: PropTypes.bool,
  submitted: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.any,
  onClick: PropTypes.func,
};

export default HomeworkMilestone;
